import React from 'react';

export default function TutorialConfirmDialog({
  open,
  title = '确认删除',
  message,
  confirming = false,
  error = '',
  confirmLabel = '删除',
  cancelLabel = '取消',
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="tutorial-apply-backdrop tutorial-apply-backdrop--top" role="presentation">
      <div
        className="tutorial-apply-modal tutorial-confirm-modal"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="tutorial-confirm-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h3 id="tutorial-confirm-title">{title}</h3>
        {message ? <p className="tutorial-apply-modal__hint">{message}</p> : null}
        {error ? <p className="tutorial-apply-modal__error">{error}</p> : null}
        <div className="tutorial-apply-modal__actions">
          <button
            type="button"
            className="tutorial-manual__ghost-btn"
            disabled={confirming}
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className="tutorial-manual__danger-btn"
            disabled={confirming}
            onClick={onConfirm}
          >
            {confirming ? '删除中…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
